import { Grid } from '@mui/material'
import React from 'react'
import TourCardserv from './TourCardserv'
import s1 from "../assets/Desktop/1.jpg"
import s2 from "../assets/Desktop/2.jpg"
import s3 from "../assets/Desktop/3.jpg"
import s4 from "../assets/Desktop/4.jpg"
import s5 from "../assets/Desktop/5.jpg"
import s6 from "../assets/Desktop/6.jpg"
import s7 from "../assets/Desktop/7.jpg"
import s8 from "../assets/Desktop/8.jpg"
import s9 from "../assets/Desktop/9.jpg"
import s10 from "../assets/Desktop/10.jpg"
import s11 from "../assets/Desktop/11.jpg"
import s12 from "../assets/Desktop/12.jpg"
import s16 from "../assets/Desktop/16.jpg"
import s17 from "../assets/Desktop/17.jpg"
import s18 from "../assets/Desktop/18.jpg"
import s13 from "../assets/Desktop/new111.jpg"
import s14 from "../assets/Desktop/new2.jpg"
import s15 from "../assets/Desktop/prof pic.jpg"

function ToursListServ() {
    return (
        <>
            <Grid container>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s1} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s2} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s3} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s5} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s4} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s6} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s7} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s8} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s9} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s10} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s11} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s12} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s13} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s14} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s17} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s15} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s16} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TourCardserv imgs={s18} />
                </Grid>
            </Grid>
        </>
    )
}

export default ToursListServ